import { render, staticRenderFns } from "./labelText.vue?vue&type=template&id=d913bbe4&"
import script from "./labelText.vue?vue&type=script&lang=js&"
export * from "./labelText.vue?vue&type=script&lang=js&"
import style0 from "./labelText.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports